import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createVNode as _createVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "top-layer" }
const _hoisted_2 = {
  key: 0,
  class: "loading-transparency"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "spinner" })
], -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "account-info-container" }
const _hoisted_6 = { class: "default-banner-container" }
const _hoisted_7 = { class: "coupon-offer-banner-version-container" }
const _hoisted_8 = { class: "coupon-banners-container" }
const _hoisted_9 = {
  key: 0,
  class: "coupon-line-division"
}
const _hoisted_10 = { class: "banner-container" }
const _hoisted_11 = { class: "version-container" }
const _hoisted_12 = { class: "top-layer" }
const _hoisted_13 = { class: "image-container" }
const _hoisted_14 = ["src"]

export function render(_ctx, _cache) {
  const _component_ModalBanner = _resolveComponent("ModalBanner")
  const _component_ModalRightFullPageNotification = _resolveComponent("ModalRightFullPageNotification")
  const _component_LoadingBar = _resolveComponent("LoadingBar")
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")
  const _component_AccountInfo = _resolveComponent("AccountInfo")
  const _component_DefaultBanner = _resolveComponent("DefaultBanner")
  const _component_FreeCoupon = _resolveComponent("FreeCoupon")
  const _component_Campaign = _resolveComponent("Campaign")
  const _component_BannersList = _resolveComponent("BannersList")
  const _component_SpecialStore = _resolveComponent("SpecialStore")
  const _component_VoucherReward = _resolveComponent("VoucherReward")
  const _component_PremiumReward = _resolveComponent("PremiumReward")
  const _component_Banners = _resolveComponent("Banners")
  const _component_VersionCopyright = _resolveComponent("VersionCopyright")
  const _component_ModalEditProfilePage = _resolveComponent("ModalEditProfilePage")
  const _component_ModalRightFullPage = _resolveComponent("ModalRightFullPage")
  const _component_ModalIframe = _resolveComponent("ModalIframe")
  const _component_ModalBottom = _resolveComponent("ModalBottom")
  const _component_ModalBottomBarcode = _resolveComponent("ModalBottomBarcode")
  const _component_ModalBottomNotification = _resolveComponent("ModalBottomNotification")
  const _component_ModalBottomTieredPoints = _resolveComponent("ModalBottomTieredPoints")
  const _component_CoinHistoryPage = _resolveComponent("CoinHistoryPage")
  const _component_ModalBottomCoinHistory = _resolveComponent("ModalBottomCoinHistory")
  const _component_NewModalRightFullPage = _resolveComponent("NewModalRightFullPage")
  const _component_AlertMessage = _resolveComponent("AlertMessage")
  const _component_ModalBottomDynamic = _resolveComponent("ModalBottomDynamic")
  const _component_ModalCenterScreen = _resolveComponent("ModalCenterScreen")

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["home-section", {'gold-tier': _ctx.store.state.tier?.tierName?.toLocaleLowerCase() === 'gold' && _ctx.customerInfo?.customerType === 'loyalty'}])
  }, [
    _createElementVNode("div", null, [
      (_ctx.isModalBannerActive)
        ? (_openBlock(), _createBlock(_component_ModalBanner, {
            key: 0,
            modalOptions: _ctx.modalOptionsBanner,
            redirectToWebRegister: _ctx.redirectToWebRegister
          }, null, 8, ["modalOptions", "redirectToWebRegister"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", null, [
      (!_ctx.isOnline || !_ctx.isTimeout || _ctx.isTokenExpired)
        ? (_openBlock(), _createBlock(_component_ModalRightFullPageNotification, {
            key: 0,
            modalOptions: _ctx.modalOptionsRightFullPageNotification
          }, null, 8, ["modalOptions"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass({ fadeOut: _ctx.startToFadeOut })
    }, [
      (_ctx.isLoading && _ctx.isOnline && _ctx.isTimeout)
        ? (_openBlock(), _createBlock(_component_LoadingBar, {
            key: 0,
            labelHtml: _ctx.loadingBarLabelHtml
          }, null, 8, ["labelHtml"]))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isLoadingSpinner && !_ctx.isModalEditProfilePageActive)
        ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isShowingLoadingTransparency)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    (!_ctx.isLoading || _ctx.loadingBarLabelHtml || (_ctx.isLoading && !_ctx.isUnlinkActive))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_5, [
            (_ctx.lineInfo !== undefined)
              ? (_openBlock(), _createBlock(_component_AccountInfo, {
                  key: 0,
                  openModalUnlinkConfirmation: _ctx.openModalUnlinkConfirmation,
                  forceUpdate: _ctx.forceUpdate,
                  openModalBarcode: _ctx.openModalBarcode
                }, null, 8, ["openModalUnlinkConfirmation", "forceUpdate", "openModalBarcode"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_DefaultBanner, {
              defaultConfig: _ctx.defaultConfig,
              onHandleClickBanner: _ctx.handleClickBanner
            }, null, 8, ["defaultConfig", "onHandleClickBanner"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_FreeCoupon),
              _createVNode(_component_Campaign, { pushModal: _ctx.pushModal }, null, 8, ["pushModal"]),
              _createVNode(_component_BannersList),
              _createVNode(_component_SpecialStore),
              _createVNode(_component_VoucherReward),
              _createVNode(_component_PremiumReward)
            ]),
            (_ctx.isCouponLineDivisionActive)
              ? (_openBlock(), _createElementBlock("hr", _hoisted_9))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_Banners)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_VersionCopyright, { copyRightDate: _ctx.copyRightDate }, null, 8, ["copyRightDate"])
            ])
          ]),
          (_ctx.isModalEditProfilePageActive)
            ? (_openBlock(), _createBlock(_component_ModalEditProfilePage, {
                key: 0,
                openModalUnlinkConfirmation: _ctx.openModalUnlinkConfirmation
              }, null, 8, ["openModalUnlinkConfirmation"]))
            : _createCommentVNode("", true),
          (_ctx.isModalRightFullPageActive)
            ? (_openBlock(), _createBlock(_component_ModalRightFullPage, {
                key: 1,
                onClose: _ctx.onModalUnlinkConfirmationClose,
                modalOptions: _ctx.modalOptionsUnlinkConfirmation
              }, null, 8, ["onClose", "modalOptions"]))
            : _createCommentVNode("", true),
          _createVNode(_component_ModalIframe),
          (_ctx.isModalActive)
            ? (_openBlock(), _createBlock(_component_ModalBottom, {
                key: 2,
                onClose: _ctx.onModalClose,
                modalOptions: _ctx.modalOptionsUnlink,
                isInProgress: _ctx.isInProgress,
                idToken: _ctx.lineInfo.idToken
              }, null, 8, ["onClose", "modalOptions", "isInProgress", "idToken"]))
            : _createCommentVNode("", true),
          (_ctx.isModalBarcodeActive)
            ? (_openBlock(), _createBlock(_component_ModalBottomBarcode, {
                key: 3,
                onClose: _ctx.onModalBarcodeClose
              }, null, 8, ["onClose"]))
            : _createCommentVNode("", true),
          (_ctx.isModalNotificationActive)
            ? (_openBlock(), _createBlock(_component_ModalBottomNotification, {
                key: 4,
                onClose: _ctx.onModalNotificationClose,
                modalOptions: _ctx.modalOptionsNotification
              }, null, 8, ["onClose", "modalOptions"]))
            : _createCommentVNode("", true),
          (_ctx.isModalTieredPointsActive)
            ? (_openBlock(), _createBlock(_component_ModalBottomTieredPoints, { key: 5 }))
            : _createCommentVNode("", true),
          (_ctx.isCoinHistory)
            ? (_openBlock(), _createBlock(_component_CoinHistoryPage, { key: 6 }))
            : _createCommentVNode("", true),
          (_ctx.isModalCalendarCoinHistory)
            ? (_openBlock(), _createBlock(_component_ModalBottomCoinHistory, { key: 7 }))
            : _createCommentVNode("", true),
          _createVNode(_component_NewModalRightFullPage, {
            modals: _ctx.modals,
            onRemoveModal: _ctx.removeModal
          }, null, 8, ["modals", "onRemoveModal"]),
          _createElementVNode("div", _hoisted_12, [
            (_ctx.isAlertMessageActive)
              ? (_openBlock(), _createBlock(_component_AlertMessage, { key: 0 }))
              : _createCommentVNode("", true)
          ])
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.isShowOnBoarding)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "on-boarding-page",
          style: _normalizeStyle({backgroundColor: _ctx.onBoardingOption.backgroundColor})
        }, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("img", {
              class: "image-onboarding",
              onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.navigateOnboarding && _ctx.navigateOnboarding(...args))),
              src: _ctx.onBoardingOption.image,
              alt: "image-onboarding"
            }, null, 8, _hoisted_14)
          ]),
          (_ctx.onBoardingOption.destinationUrl)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "action",
                onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.navigateOnboarding && _ctx.navigateOnboarding(...args)))
              }, [
                _createElementVNode("button", null, _toDisplayString(_ctx.onBoardingOption.buttonText), 1)
              ]))
            : _createCommentVNode("", true)
        ], 4))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newModals.filter((_modal) => _modal.type === 'modal-bottom-dynamic'), (modal) => {
      return (_openBlock(), _createBlock(_component_ModalBottomDynamic, {
        key: `modal_${modal.name}`,
        modal: modal,
        removeModal: _ctx.removeNewModal
      }, null, 8, ["modal", "removeModal"]))
    }), 128)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newModals.filter((_modal) => _modal.type === 'modal-center-screen'), (modal) => {
      return (_openBlock(), _createBlock(_component_ModalCenterScreen, {
        key: `modal_${modal.name}`,
        modal: modal,
        removeModal: _ctx.removeNewModal
      }, null, 8, ["modal", "removeModal"]))
    }), 128))
  ], 2))
}